import {Box, BoxProps} from "@mui/material";
import {FC} from "react";
import {ICourse} from "@buildwitt/shapeshift-types/ICourse";
import {IAPIDrivenChildrenFunction} from "@buildwitt/shapeshift-common/types/ICommon";
import TodayLearningSection from "@/app2/pages/HomePage/TodayLearningSection/TodayLearningSection";
import EnrolledCoursesSection from "@/app2/pages/HomePage/EnrolledCoursesSection/EnrolledCoursesSection";

interface IPropsCustom {
	data?: ICourse[];
	children?: IAPIDrivenChildrenFunction<ICourse[] | undefined>;
}

export type IProps = Omit<BoxProps, "children"> & IPropsCustom;

export const HomeContent: FC<IProps> = () => {

	return (
		<Box>
			<TodayLearningSection/>
			<EnrolledCoursesSection/>
		</Box>
	);
};

export default HomeContent;
